/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import React, { useCallback, useState } from 'react';
import { Box, Button, IconButton, Tooltip } from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';
import { MaterialReactTable } from 'material-react-table';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { COLOR_PRIMARY, COLOR_SECONDARY } from 'styles/theme';
import { withStyles } from '@material-ui/core';
import { ContactsEditRecordModal, ContactsCreateRecordModal } from './contactsModals.component';

const styles = theme => ({
  editModalContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100% !important',
    marginLeft: '0px !important',
  },
  editModalColumn: {
    display: 'flex',
    flexDirection: 'column',
    width: '100% !important',
  },
  editModalInput: {
    minWidth: '332px',
  },
  dialogContentContainer: {
    margin: '15px',
  }
});

const theme = createTheme({
  palette: {
    primary: {
      main: COLOR_PRIMARY.main,
    },
    secondary: {
      main: COLOR_SECONDARY.main,
    },
  },
});

/**
 * Custom Contacts Table with Google Places Autocomplete
 */
const ContactsTable = ({
  classes,
  columns,
  rows,
  createRow,
  updateRow,
  deleteRow,
  customAddText,
  hideEdit,
  countriesEnum,
  provincesEnum,
  isLoading = false,
}) => {
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [editingRow, setEditingRow] = useState(null);
  const [editingModalOpen, setEditingModalOpen] = useState(false);
  const [tableData, setTableData] = useState(() => rows);

  // Update table data when rows prop changes
  React.useEffect(() => {
    setTableData(rows);
  }, [rows]);

  const handleCreateNewRow = async (values) => {
    const result = await createRow(values);
    if (result !== false) {
      setCreateModalOpen(false);
    }
  };

  const handleSaveRowEdits = async (values, row) => {
    const result = await updateRow(row, values);
    if (result !== false) {
      setEditingModalOpen(false);
      setEditingRow(null);
    }
  };

  const handleDeleteRow = useCallback(
    async (row) => {
      if (!window.confirm(`Are you sure you want to delete this contact?`)) {
        return;
      }
      await deleteRow(row);
    },
    [deleteRow],
  );

  const handleEditRow = (row) => {
    setEditingRow(row);
    setEditingModalOpen(true);
  };

  const hideColumns = columns => {
    let hiddenCols = {};
    columns.map((col) => {
      if (col.hideInTable) {
        hiddenCols[col.accessorKey] = false;
      }
    });
    return hiddenCols;
  };

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
            margin: 1,
            overflow: 'hidden',
        }}
      >
        <MaterialReactTable
            displayColumnDefOptions={{
            'mrt-row-actions': {
                muiTableHeadCellProps: {
                align: 'center',
                },
                size: 120,
            },
            }}
            muiTableBodyRowProps={({ row }) => {
              //conditionally style rows
              const isPrimary =
              row.original.isPrimary;
              const enableRowHoverHighlight = !isPrimary; // Only enable hover highlight for non-primary rows
              const rowHoverColor = '#f5f5f5'; // Light gray hover color
            return {
              sx: {
                // cursor: onRowClick ? 'pointer' : 'default',
                backgroundColor: isPrimary ? '#bfe4b1' : undefined,
                ':hover': {
                  backgroundColor: isPrimary
                    ? '#bfe4b1'
                    : enableRowHoverHighlight
                      ? rowHoverColor
                      : undefined,
                },
              },
            };
            }}
            columns={columns}
            data={tableData}
            editingMode="modal"
            enableColumnOrdering={false}
            enableEditing={!hideEdit}
            enableSorting={false}
            enablePagination={false}
            enableBottomToolbar={false}
            enableColumnActions={false}
            positionActionsColumn="first"
            initialState={{ columnVisibility: hideColumns(columns) }}
            renderRowActions={({ row, table }) => (
            <Box sx={{ display: 'flex', gap: '1rem', justifyContent: 'center' }}>
                {!hideEdit && (
                <Tooltip arrow placement="left" title="Edit">
                    <IconButton onClick={() => handleEditRow(row)}>
                    <Edit />
                    </IconButton>
                </Tooltip>
                )}
                {!hideEdit && (
                <Tooltip arrow placement="right" title="Delete">
                    <IconButton color="error" onClick={() => handleDeleteRow(row)}>
                    <Delete />
                    </IconButton>
                </Tooltip>
                )}
            </Box>
            )}
            renderTopToolbarCustomActions={() => (
            !hideEdit && (
                <Button
                color="primary"
                onClick={() => setCreateModalOpen(true)}
                variant="contained"
                sx={{color: 'white'}}
                >
                {customAddText || 'Add Record'}
                </Button>
            )
            )}
        />

        {/* Edit Modal */}
        {editingRow && (
          <ContactsEditRecordModal
            open={editingModalOpen}
            classes={classes}
            columns={columns}
            onClose={() => {
              setEditingModalOpen(false);
              setEditingRow(null);
            }}
            onSubmit={handleSaveRowEdits}
            row={editingRow}
            hideEdit={hideEdit}
            isLoading={isLoading}
            countriesEnum={countriesEnum}
            provincesEnum={provincesEnum}
          />
        )}

        {/* Create Modal */}
        <ContactsCreateRecordModal
          open={createModalOpen}
          classes={classes}
          columns={columns}
          onClose={() => setCreateModalOpen(false)}
          onSubmit={handleCreateNewRow}
          hideEdit={hideEdit}
          isLoading={isLoading}
          countriesEnum={countriesEnum}
          provincesEnum={provincesEnum}
        />
      </Box>
    </ThemeProvider>
  );
};

export default withStyles(styles)(ContactsTable);
